import React from 'react'

import * as Footers from '../Footers'
import { Navigator } from '../Headers'
import { oftmcssSrc } from '../../svg'

// Create a local version of EpcLogoXL to avoid circular dependency
const LocalEpcLogoXL: React.FC = () => (
  <div className="flex font-body bg-primary p-2">
    <img
      src={oftmcssSrc}
      alt=""
      style={{ width: '8rem' }}
      className="h-auto my-auto mr-2"
    />
    <h1 className="flex flex-col p-0 m-0 font-extrabold leading-none text-lg">
      <p className="text-white">Educator</p>
      <p>
        <span className="text-accent">PRO</span>{' '}
        <span className="text-white">Connect</span>
      </p>
    </h1>
  </div>
)

const SHARED_STYLES = 'overflow-x-hidden bg-transparent w-full'

const SPLASH_CONTENT_WRAPPER_STYLES = `${SHARED_STYLES} xl:w-1/3 pt-8`

const CHILDREN_WRAPPER_STYLES = `${SHARED_STYLES} xl:w-2/3 ml-0 pt-0 -mt-8 lg:mt-0 md:pt-8 xl:ml-24`

const REGION_STYLES = 'm-0 box-border mr-auto max-w-xl'

const VIEW_CONTENT_STYLES =
  'flex flex-col flex-grow flex-shrink h-auto lg:flex-row'

const CONTAINER_STYLES =
  'flex flex-col m-0 box-border h-auto w-screen overflow-x-hidden'

export interface IMinimalistViewProps {
  footerImageSrc: string
  splashContent?: JSX.Element
  children: JSX.Element | JSX.Element[]
}

/**
 * A responsive template that displays a collapsable two column layout.
 * @param props A configuration for the content and display of this template.
 */
export const MinimalistView: React.FC<IMinimalistViewProps> = (props) => (
  <div className={CONTAINER_STYLES}>
    <Navigator logo={LocalEpcLogoXL} />
    <div className={VIEW_CONTENT_STYLES}>
      <div className={SPLASH_CONTENT_WRAPPER_STYLES}>
        <div className={REGION_STYLES}>{props.splashContent}</div>
      </div>
      <div className={CHILDREN_WRAPPER_STYLES}>
        <div className={REGION_STYLES}>{props.children}</div>
      </div>
    </div>
    <Footers.Standard footerImageSrc={props.footerImageSrc} />
  </div>
)
